import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';

const selectSx = {
  height: '40px',
  borderRadius: '8px',
  fontSize: '0.875rem',
  minWidth: 160,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
};

const textSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fff',
    height: '40px',
    '& fieldset': { borderColor: '#E0E0E0' },
    '&:hover fieldset': { borderColor: '#BDBDBD' },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
  '& input': { fontSize: '0.875rem' },
};

const STATUS_OPTIONS = [
  { value: 'pending', label: 'Pendentes' },
  { value: 'processing', label: 'Em envio' },
  { value: 'sent', label: 'Enviadas' },
  { value: 'failed', label: 'Falhas' },
  { value: 'canceled', label: 'Canceladas' },
  { value: 'all', label: 'Todas' },
];

/**
 * OutboxFilters - Barra de filtros da tela "Fila WhatsApp" (Admin Geral)
 * @param {Object} props
 * @param {string} props.status
 * @param {Function} props.onStatusChange
 * @param {string} props.companyInput
 * @param {Function} props.onCompanyInputChange
 * @param {Array<string>} props.automationTypes - automações existentes na fila
 * @param {string} props.automationType
 * @param {Function} props.onAutomationTypeChange
 * @param {Array<string>} props.messageKinds - tipos de mensagem existentes na fila
 * @param {string} props.messageKind
 * @param {Function} props.onMessageKindChange
 * @param {string} props.priority
 * @param {Function} props.onPriorityChange
 * @param {string} props.dateFrom
 * @param {Function} props.onDateFromChange
 * @param {string} props.dateTo
 * @param {Function} props.onDateToChange
 */
function OutboxFilters({
  status,
  onStatusChange,
  companyInput,
  onCompanyInputChange,
  automationTypes = [],
  automationType,
  onAutomationTypeChange,
  messageKinds = [],
  messageKind,
  onMessageKindChange,
  priority,
  onPriorityChange,
  dateFrom,
  onDateFromChange,
  dateTo,
  onDateToChange,
}) {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        borderBottom: '1px solid #E8ECF0',
        bgcolor: '#fff',
      }}
    >
      <Select size="small" value={status || 'pending'} onChange={(e) => onStatusChange(e.target.value)} sx={selectSx}>
        {STATUS_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
        ))}
      </Select>

      <TextField
        size="small"
        placeholder="Empresa (nome ou id)"
        value={companyInput}
        onChange={(e) => onCompanyInputChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.disabled', fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, minWidth: 220, maxWidth: { sm: 300 }, ...textSx }}
      />

      <Select
        size="small"
        displayEmpty
        value={automationType || ''}
        onChange={(e) => onAutomationTypeChange(e.target.value)}
        sx={selectSx}
      >
        <MenuItem value="">Todas as automações</MenuItem>
        {automationTypes.map((type) => (
          <MenuItem key={type} value={type}>{type}</MenuItem>
        ))}
      </Select>

      <Select
        size="small"
        displayEmpty
        value={messageKind || ''}
        onChange={(e) => onMessageKindChange(e.target.value)}
        sx={selectSx}
      >
        <MenuItem value="">Todos os tipos</MenuItem>
        {messageKinds.map((kind) => (
          <MenuItem key={kind} value={kind}>{kind}</MenuItem>
        ))}
      </Select>

      <Select
        size="small"
        displayEmpty
        value={priority ?? ''}
        onChange={(e) => onPriorityChange(e.target.value)}
        sx={{ ...selectSx, minWidth: 140 }}
      >
        <MenuItem value="">Todas as prioridades</MenuItem>
        <MenuItem value="0">Operacional</MenuItem>
        <MenuItem value="1">Massa</MenuItem>
      </Select>

      <TextField
        size="small"
        type="date"
        label="Agendado de"
        InputLabelProps={{ shrink: true }}
        value={dateFrom}
        onChange={(e) => onDateFromChange(e.target.value)}
        sx={{ width: 170, ...textSx }}
      />

      <TextField
        size="small"
        type="date"
        label="Até"
        InputLabelProps={{ shrink: true }}
        value={dateTo}
        onChange={(e) => onDateToChange(e.target.value)}
        sx={{ width: 160, ...textSx }}
      />
    </Box>
  );
}

export default OutboxFilters;
